// i18n public API — re-exports init + utility функции для locale resolution.
//
// Used by:
//   - src/main.tsx: вызывает initI18n до render
//   - feature components: useTranslation() из react-i18next

export {
  DEFAULT_LOCALE,
  initI18n,
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from "./init";

import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type SupportedLocale } from "./init";

/**
 * Normalize Telegram language_code → supported locale.
 *
 * Telegram передаёт RFC 5646 codes (e.g. "tr-TR", "bg-BG", "en-US").
 * Mini App поддерживает только base subtag (Phase 1: en/tr/bg).
 * Unknown locale (e.g. "zh-CN") → fallback на DEFAULT_LOCALE.
 *
 * @param languageCode - raw initData.user.languageCode (может быть undefined/empty)
 * @returns valid SupportedLocale
 *
 * @example
 *   resolveTelegramLocale("tr-TR")  // "tr"
 *   resolveTelegramLocale("zh-CN")  // "en" (fallback)
 *   resolveTelegramLocale(undefined) // "en"
 */
export function resolveTelegramLocale(languageCode: string | undefined | null): SupportedLocale {
  if (!languageCode) {
    return DEFAULT_LOCALE;
  }
  const base = languageCode.split("-")[0]?.toLowerCase().trim() ?? "";
  if (SUPPORTED_LOCALES.includes(base as SupportedLocale)) {
    return base as SupportedLocale;
  }
  return DEFAULT_LOCALE;
}
